import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { UserService } from '@delfi-gui/components';
import { take } from 'rxjs/operators';
import { AppState } from '../store';
import { AuthActions } from '../store/auth/auth.actions';
import { mapContextToUserAccount } from '../models/user.model';

/** Loads the Delfi user context and dispatches userContextLoaded into the store. */
@Injectable({ providedIn: 'root' })
export class UserContextService {
  private readonly userService = inject(UserService);
  private readonly store = inject(Store<AppState>);

  private readonly RETRY_DELAY_MS = 3_000;

  load(source: string): void {
    console.log(`[UserContext] Loading context (source: ${source})`);
    this.fetchContext(source, 1);
  }

  private fetchContext(source: string, retriesLeft: number): void {
    this.userService.getContext().pipe(take(1)).subscribe({
      next: (ctx) => {
        console.log(`[UserContext] Loaded — account: ${ctx.accountName} (${ctx.crmAccountId})`);
        this.store.dispatch(AuthActions.userContextLoaded({ account: mapContextToUserAccount(ctx) }));
      },
      error: (err) => {
        if (retriesLeft > 0) {
          console.warn(`[UserContext] Failed (source: ${source}), retrying in ${this.RETRY_DELAY_MS / 1000}s:`, err?.status, err?.message);
          setTimeout(() => this.fetchContext(source, retriesLeft - 1), this.RETRY_DELAY_MS);
        } else {
          console.warn(`[UserContext] Failed to load context after retry (source: ${source}):`, err?.status, err?.message);
        }
      },
    });
  }
}
